const LangHeader = {
	"header.topMenu._benefits": ["Benefits", "Quyền lợi"],
	"header.topMenu._mobile_app": ["Mobile app", "Ứng dụng điện thoại"],
	"header.topMenu._view_card_designs": ["Card designs", "Các mẫu thẻ"],
	"header.topMenu._faqs": ["FAQS", "Câu hỏi thường gặp"],
	"header.topMenu._login_signin": ["Sign in", "Đăng nhập"],
	"header.topMenu._login_signup": ["Join now", "Đăng ký"],
	"header.topMenu._starbucksEgift": ["Starbucks eGift", "Starbucks eGift"],
}

export default LangHeader



// WEBPACK FOOTER //
// ./src/resources/modules/LangHeader.js